export const SOCKET_EVENTS = Object.freeze({
  GET_LESSON_PACING: 'get-lesson-pacing',
  UPDATE_LESSON_PACING: 'update-lesson-pacing',
  LESSON_PACING_STATE: 'lesson-pacing-state',
  LESSON_PACING_TEACHER_STATE: 'lesson-pacing-teacher-state',
  TUTOR_SIGNAL: 'tutor-signal',
  LEGACY_TUTOR_SIGNAL: 'totur-signal',
  STUDENT_SIGNAL: 'student-signal',
  WHITEBOARD_TUTOR_SIGNAL: 'white-board-tutor-signal',
  LEGACY_WHITEBOARD_TUTOR_SIGNAL: 'white-board-totur-signal',
  SCREEN_SHARING_TUTOR_SIGNAL: 'screen-sharing-tutor-signal',
  LEGACY_SCREEN_SHARING_TUTOR_SIGNAL: 'screen-sharing-totur-signal',
});
